<div class="tree-top-menu">
  <div>
    <button mat-raised-button color="primary" (click)="back()">Back</button>
    &nbsp;
    <button style="background-color: coral" [disabled]="pending" mat-raised-button color="primary" (click)="rebuild()">Refresh</button>
    &nbsp;
    <button style="background-color: #658658" (click)="showReplaceDialog()" mat-raised-button color="primary">🦄 Replace 🦄</button>
    &nbsp;
    <button style="background-color: #14a19c" (click)="getGptLastUpdate()" mat-raised-button color="primary">Last GPT update results</button>
    &nbsp;
  </div>
  <div class="top-items">
    <mat-form-field style="width: 80px;" class="example-form-field" appearance="fill">
      <mat-label>Top</mat-label>
      <input matInput type="number" min="0" [(ngModel)]="topValue">
    </mat-form-field>
    <mat-form-field style="width: 90px;" class="example-form-field" appearance="fill">
      <mat-label>Slice start</mat-label>
      <input matInput type="number" min="0" [(ngModel)]="topSliceValue">
    </mat-form-field>
    <mat-form-field style="width: 90px;" class="example-form-field" appearance="fill">
      <mat-label>Slice end</mat-label>
      <input matInput type="number" min="0" [(ngModel)]="topEndSliceValue">
    </mat-form-field>
    <mat-checkbox class="example-margin" [(ngModel)]="fullCompliance"></mat-checkbox>
    <button [disabled]="getTopFilePending" mat-raised-button (click)="getTop()" color="primary">Get Top</button>

    <button [matMenuTriggerFor]="deleteMenu" style="float: right;" matTooltip="Export" mat-icon-button>
      <mat-icon>file_download</mat-icon>
    </button>
    <mat-menu class="primary" #deleteMenu="matMenu">
      <button (click)="exportTop()" [disabled]="!topFilterIsActive" mat-menu-item>Export Top (Compare)</button>
      <button (click)="exportTopAll()" [disabled]="pendingTopAllExport" mat-menu-item>Export Top All</button>
      <button (click)="exportStats()" [disabled]="pendingStatsExport" mat-menu-item>Export Unique categories</button>
    </mat-menu>
  </div>
  <!--<button mat-raised-button color="warn" (click)="rebuild()">Rebuild Tree</button>-->
</div>
<div class="tree-grid">
  <ag-grid-angular
    style="width: 100%; height: 62vh;"
    class="ag-theme-alpine"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [rowData]="rowData"
    [treeData]="true"
    [groupAggFiltering]="true"
    [suppressAggFilteredOnly]="true"
    [excludeChildrenWhenTreeDataFiltering]="false"
    [animateRows]="true"
    [getRowId]="getRowId"
    [rowDragManaged]="true"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
    [rowSelection]="rowSelection"
    [groupDefaultExpanded]="0"
    (rowClicked)="onRowClick($event)"
    (selectionChanged)="treeSelectionChanged($event)"
    (filterChanged)="filterChanged($event)"
    [sendToClipboard]="sendToClipboard"
    [getDataPath]="getDataPath"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
  <div>
<!--    <button mat-raised-button (click)="moveProducts()" color="primary">move</button>-->
    <button [disabled]="!productDetailSelected" mat-raised-button (click)="moveProducts()" color="primary">move</button>
    <ag-grid-angular
      style="width: 100%; height: 60vh;"
      class="ag-theme-alpine"
      [columnDefs]="columnDefsProducts"
      [statusBar]="statusBar"
      [defaultColDef]="defaultColDefProducts"
      [rowData]="productsGridData"
      [animateRows]="true"
      [rowSelection]="'multiple'"
      [masterDetail]="false"
      [detailCellRendererParams]="detailCellRendererParams"
      [detailRowHeight]="220"
      [groupDefaultExpanded]="groupDefaultExpanded"
      [getContextMenuItems]="getContextMenuItems"
      (selectionChanged)="productsSelectionChanged($event)"
    ></ag-grid-angular>
<!--    <div class="inner-products">-->
<!--      <div class="inner-products__item" *ngFor="let item of productsGridData">-->
<!--        <div class="inner-products__item-head">-->
<!--          <a href="https://blackhawksupply.com/products/{{item.handle}}" target="_blank">{{item.sku}}</a>-->
<!--          &nbsp; | &nbsp;{{item.product_id}} &nbsp;|&nbsp; {{item.brand}}-->
<!--        </div>-->
<!--        <div class="inner-products__item-body">-->
<!--          {{item.body}}-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</div>
<br>
<h1 style="margin-left: 15px;">{{parents.join(' > ')}}</h1>
<hr>
<pre style="max-width: 100vw; overflow: scroll;" *ngIf="Object.keys(productDetail).length">{{productDetail | json}}</pre>
<h2 *ngIf="Object.keys(tops).length">TOP: {{topValue}}</h2>
<pre style="height: 20vh;max-width: 100vw; overflow: scroll;" *ngIf="Object.keys(tops).length">{{tops | json}}</pre>

